type VoucherLabelFields = {
  voucherIssuer?: string | null;
  voucherCode?: string | null;
};

export const formatVoucherLabel = (
  { voucherIssuer, voucherCode }: VoucherLabelFields,
  fallback: string,
): string => {
  if (!voucherIssuer) {
    return fallback;
  }
  if (!voucherCode) {
    return voucherIssuer;
  }
  return `${voucherIssuer} (${voucherCode})`;
};

export const getByType = <T>(isCancellation: boolean, ifCheckout: T, ifCancellation: T): T =>
  isCancellation ? ifCancellation : ifCheckout;

export type RedeemedVoucherLineItem = VoucherLabelFields & { id?: number; amount: number };

export type VoucherPaymentFields = VoucherLabelFields & {
  type?: string;
  paymentType?: string;
  amount: number;
};

const VOUCHER_PAYMENT_TYPES = ['VCHR', 'VOUCHER'];

const mirrorsRedeemedVoucher = (
  payment: VoucherPaymentFields,
  voucher: RedeemedVoucherLineItem,
): boolean =>
  (payment.voucherIssuer ?? null) === (voucher.voucherIssuer ?? null) &&
  (payment.voucherCode ?? null) === (voucher.voucherCode ?? null) &&
  Math.abs(payment.amount) === Math.abs(voucher.amount);

// Rollout guard (TEF-4632): until the POS change is live, payments[] still echoes a redeemed gift card as VCHR/VOUCHER.
export const excludeRedeemedVoucherPayments = <P extends VoucherPaymentFields>(
  payments: P[],
  redeemedVouchers?: RedeemedVoucherLineItem[] | null,
): P[] => {
  if (!redeemedVouchers?.length) {
    return payments;
  }
  return payments.filter(
    (payment) =>
      !VOUCHER_PAYMENT_TYPES.includes(payment.type ?? payment.paymentType ?? '') ||
      !redeemedVouchers.some((voucher) => mirrorsRedeemedVoucher(payment, voucher)),
  );
};
